import React from 'react';

const VendorMasterPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default VendorMasterPage;
